import type { MessageKey } from './en.ts';

export const tr: Record<MessageKey, string> = {
  'app.title': 'Chaos Lane',
  'app.round': 'Tur {id}',
  'mode.LIVE': 'CANLI',
  'mode.DELAYED_LIVE': 'GECİKMELİ CANLI',
  'mode.RECORDED_DEMO': 'KAYIT DEMO',
  'mode.SIMULATION': 'SİMÜLASYON',
  'mode.SIMULATION.hint': 'Sayımlar kamera analizinden değil, senaryolu bir fixture’dan gelir.',
  'conn.connected': 'Bağlı',
  'conn.reconnecting': 'Yeniden bağlanıyor…',
  'conn.offline': 'Çevrimdışı',
  'conn.banner': 'Bağlantı koptu. Oyun yeniden bağlanana kadar bahis durduruldu; kabul edilmiş bahisler sunucuda güvende.',
  'balance.demo': 'Demo bakiye',
  'balance.demoTag': 'DEMO',
  'balance.real': 'Bakiye',
  'nav.history': 'Geçmiş',
  'nav.rules': 'Kurallar',
  'nav.settings': 'Ayarlar',
  'nav.close': 'Kapat',
  'state.SCHEDULED': 'Planlandı',
  'state.BETTING_OPEN': 'Bahis açık',
  'state.BETTING_CLOSED': 'Bahis kapandı',
  'state.CAPTURING': 'Sayılıyor',
  'state.VERIFYING': 'Doğrulanıyor',
  'state.REVIEW_REQUIRED': 'İnceleme gerekli',
  'state.RESULT_FINAL': 'Sonuç kesin',
  'state.SETTLING': 'Ödeniyor',
  'state.SETTLED': 'Sonuçlandı',
  'state.VOIDING': 'İptal ediliyor',
  'state.VOIDED': 'İptal edildi',
  'phase.closesIn': 'Bahis kapanışına',
  'phase.countStartsIn': 'Sayımın başlamasına',
  'phase.countEndsIn': 'Sayımın bitmesine',
  'phase.reviewDeadline': 'İnceleme süresinin bitmesine',
  'phase.nextRound': 'Yeni tur birazdan',
  'phase.seconds': '{n} sn',
  'count.label': 'Sayım',
  'count.bands': 'L = {low} · H = {high}',
  'relay.nextCamera': 'Sıradaki canlı kamera',
  'relay.starting': 'Bahisler kapandı · tur başlıyor',
  'outro.count': 'Kesin sayım',
  'outro.winning': 'Kazanan: {sel}',
  'outro.players': '{players} oyuncudan {winners} kazandı',
  'outro.noPlayers': 'Bu turda bahis yok',
  'outro.paid': 'toplam {amount} ödendi',
  'outro.voided': 'Tur iptal: kamera yayını kesildi. Bahisler iade edilir.',
  'relay.badge': 'CANLI · bizim aktarımımız',
  'relay.connecting': 'Canlı kameraya bağlanılıyor…',
  'live.count': 'Sayım',
  'live.stage': 'Canlı kamera turu',
  'live.video': 'Tur görüntüsü',
  'live.badge': 'GECİKMELİ CANLI · halka açık trafik kamerası',
  'live.provisional': 'Sayım çizgisi henüz doğrulanmadı',
  'live.status.betting': 'Bahisler açık. Bu kameranın sonraki 60 saniyesi turu belirler.',
  'live.status.capturing': 'Bahisler kapandı. Bu kameradan sonraki 60 saniye kaydediliyor…',
  'live.status.preparing': 'Görüntü kilitleniyor ve sayılıyor. Oynatma birazdan başlıyor.',
  'live.status.retrying': 'Video bağlantısı kesildi, yeniden bağlanılıyor… Sonuç sizin bağlantınıza bağlı değildir.',
  'live.status.videoUnavailable': 'Görüntü şu anda bu cihazda oynatılamıyor. Sonuç sunucuda belirlenir ve tur bitince görünür.',
  'live.status.voided': 'Bu tur iptal edildi (görüntü kullanılamadı). Bahisler iade edilir.',
  'video.server.title': 'Sunucuda sayılıyor',
  'video.server.body': 'Geçişleri sunucu kendi özel kamera akışından sayar; bu ekran canlı görüntüyü göstermez. Raunttan sonra Kanıt bölümü, gizlilik için küçültülmüş görüntüyü her geçişle birlikte tekrar oynatır.',
  'evidence.lightningCommitOk': 'Açıklanan tohum taahhütle eşleşiyor ✓ (artırma çekilişi burada yeniden kontrol edilmedi: politika bu istemciye yayımlanmıyor)',
  'video.none.title': 'Bu modda video yok',
  'video.none.body': 'SİMÜLASYON: geçişler senaryolu bir fixture’dan gelir. Gerçek video sayımı henüz bağlı değil.',
  'video.testPattern': 'TEST DESENİ · overlay hizası için sentetik {ratio} kare',
  'video.clockUnknown': 'Çekim saati bilinmiyor',
  'video.lineLocked': 'Sayım çizgisi bu tur için kilitli',
  'sel.UNDER': 'Alt',
  'sel.RANGE': 'Aralık',
  'sel.OVER': 'Üst',
  'sel.EXACT': 'Sınırda',
  'sel.EXACT_LOW': 'Tam alt sınır',
  'sel.EXACT_HIGH': 'Tam üst sınır',
  'sel.LANE_A': 'A yönü',
  'sel.LANE_B': 'B yönü',
  'sel.TIE': 'Beraberlik',
  'sel.CAR': 'Otomobil',
  'sel.HEAVY': 'Ağır vasıta',
  'sel.MOTORCYCLE': 'Motosiklet',
  'sel.NO_EVENT': 'Geçiş yok',
  'sel.ZERO': 'Sıfır',
  'sel.ONE': 'Bir',
  'sel.TWO_PLUS': 'İki veya daha fazla',
  'cond.LANE_A': 'A yönünde (ok tarafı) daha çok geçiş',
  'cond.LANE_B': 'B yönünde (oka ters) daha çok geçiş',
  'cond.TIE': 'Eşit sayı, 0–0 dahil',
  'cond.CAR': 'Çizgiyi ilk geçen araç otomobil',
  'cond.HEAVY': 'İlk araç otobüs veya kamyon',
  'cond.MOTORCYCLE': 'İlk araç motosiklet',
  'cond.NO_EVENT': 'Sayım boyunca hiç araç geçmez',
  'cond.bucket.exactly': 'Tam {n}',
  'cond.bucket.atLeast': '{n} veya daha fazla',
  'cond.bucket.between': '{a} ile {b} arası',
  'duel.a': 'A (ok tarafı)',
  'duel.b': 'B (oka ters)',
  'first.waiting': 'İlk araç bekleniyor',
  'first.none': 'Hiç araç geçmedi',
  'first.is': 'İlk: {cls}',
  'count.boats': 'Tekne',
  'count.bicycles': 'Bisiklet',
  'home.live': 'Canlı kameralar',
  'home.tagline': 'Dünyanın dört bir yanındaki gerçek trafik kameraları. 60 saniye, bir çizgi, tek soru: kaç araç geçecek?',
  'home.play': 'Oyna',
  'home.chip.round': '60 sn turlar',
  'home.chip.cameras': 'Dünyadan canlı yollar',
  'home.chip.demo': 'Demo para',
  'home.chip.real': 'Gerçek para',
  'home.how': 'Nasıl oynanır',
  'home.s1.title': 'Aralığını seç',
  'home.s1.text': 'Her tur o kameranın son trafiğine göre aralıklar sunar: Az, Tam, Orta, Tam, Çok. Fişini koy, istediğin kadar ekle.',
  'home.s2.title': 'Canlı izle',
  'home.s2.text': 'Bahisler kapanır, 10’dan geri sayılır ve yayın başlar. Ok yönünde çizgiyi geçen her araç ekranda +1 olarak sayılır.',
  'home.s3.title': 'Sayı karar verir',
  'home.s3.text': '60 saniye bitince sayım kesinleşir. Kazanan aralık anında ödenir; yayın kesilirse bahisler iade edilir.',
  'home.s3.badge': 'kesin sayım',
  'home.t1.title': 'Gerçek yollar',
  'home.t1.text': 'Sonucu rastgele sayı üreteci değil, canlı kameradaki gerçek araçlar belirler.',
  'home.t2.title': 'Önceden kilitli kurallar',
  'home.t2.text': 'Kamera, çizgi ve aralıklar bahisler açılmadan sabitlenir; sayım bahisler kapandıktan sonra başlar.',
  'home.t3.title': 'Herkes aynı sayımı görür',
  'home.t3.text': 'Kutular, çizgi ve +1’ler sayan sistemin kendisinden gelir; ekranda gördüğün, sayılandır.',
  'home.foot': 'Demo sürüm · gerçek para kapalı',
  'home.foot.real': 'Gerçek para · 18+ · sorumlu oyna',
  'lobby.title': 'Oyunlar',
  'lobby.subtitle': 'Tek demo cüzdanında beş CCTV oyunu. Her birinin kuralları, değerlendiricisi ve testleri ayrı.',
  'lobby.play': 'Oyna',
  'lobby.simulation': 'Simülasyon turları',
  'lobby.videoDemo': 'Kayıt video demosu: {n} kaynak',
  'lobby.noVideo': 'Henüz lisanslı video yok',
  'lobby.realMoneyOff': 'Gerçek para: kapalı',
  'lobby.back': 'Ana sayfa',
  'game.traffic-pulse.title': 'Chaos Lane',
  'game.traffic-pulse.blurb': 'Çizgiyi kaç araç geçecek? L ve H çevresindeki bantlara bahis.',
  'game.lane-duel.title': 'Lane Duel',
  'game.lane-duel.blurb': 'Hangi yön kazanır: bir yönde daha çok geçiş, diğerinde mi, yoksa beraberlik mi?',
  'game.next-class.title': 'Next Class',
  'game.next-class.blurb': 'Çizgiyi ilk geçen araç ne: otomobil, ağır vasıta, motosiklet — ya da hiçbiri?',
  'game.cycle-count.title': 'Cycle Count',
  'game.cycle-count.blurb': 'Kaç sürülen bisiklet geçecek? İtilen bisikletler sayılmaz.',
  'game.harbor-count.title': 'Harbor Count',
  'game.harbor-count.blurb': 'Kanal çizgisini kaç tekne geçecek: hiç, bir, daha fazla?',
  'game.limit.cycle-count': 'İtilen bisiklet kuralı v1 sezgiseli (bisikletin üstünde sürücü), ölçülmedi.',
  'game.limit.harbor-count': 'Yansıma filtresi v1 sezgiseli; tek lisanslı klipte trafik seyrek.',
  'game.limit.next-class': 'Dedektörde riksha için ayrı sınıf yok (otomobil/motosiklet/kamyon görünür).',
  'rules.game': 'Kurallar ({version})',
  'source.suitable': 'Bu oyuna uygun',
  'source.otherGames': 'Diğer lisanslı kaynaklar (bu oyunla eşleşmiyor)',
  'cond.UNDER': 'Sayım {low} altında',
  'cond.RANGE': 'Sayım {low} ile {high} arasında (hariç)',
  'cond.OVER': 'Sayım {high} üstünde',
  'cond.EXACT': 'Sayım tam {low} veya {high}',
  'cond.EXACT_LOW': 'Sayım tam {low}',
  'cond.EXACT_HIGH': 'Sayım tam {high}',
  'bet.title': 'Bahis',
  'bet.exampleOdds': 'Örnek oranlar — kalibre edilmedi. Yalnızca demo para.',
  'bet.chip': 'Fiş seç',
  'bet.chipLabel': 'Fiş değeri {amount}',
  'bet.main': 'Ana bahis',
  'bet.side': 'Tam sayı',
  'bet.sideNote': 'Ayrı pazar: Tam ile birlikte kazanabilir.',
  'bet.draftOn': 'Taslak {amount}',
  'bet.acceptedOn': 'Kabul {amount}',
  'bet.addChip': '{selection} seçeneğine {amount} ekle',
  'bet.doubleHint': 'Seçimlerinizi ikiye katlar (onayı siz verirsiniz)',
  'board.question': '{sec} saniyede ok yönünde çizgiyi kaç araç geçecek?',
  'board.UNDER': 'Az',
  'board.EXACT_LOW': 'Tam',
  'board.RANGE': 'Orta',
  'board.EXACT_HIGH': 'Tam',
  'board.OVER': 'Çok',
  'board.EXACT': 'İkisinden biri',
  'board.either': '{low} / {high}',
  'sound.turnOn': 'Sesi aç',
  'sound.turnOff': 'Sesi kapat',
  'bet.undo': 'Geri al',
  'bet.clear': 'Temizle',
  'bet.repeat': 'Tekrarla',
  'bet.repeatHint': 'Yalnızca taslağı doldurur; onayı siz verirsiniz.',
  'bet.total': 'Toplam bahis',
  'bet.potential': '{selection} kazanırsa: dönüş {gross} (net {net})',
  'bet.confirm': '{amount} onayla',
  'bet.confirmEmpty': 'Bahis için fiş ekleyin',
  'bet.submitting': 'Gönderiliyor…',
  'bet.closed': 'Bahis kapandı',
  'bet.closedHint': 'Bahisler bir sonraki turda açılır.',
  'bet.offline': 'Yeniden bağlanıyor — bahis durduruldu',
  'bet.insufficient': 'Toplam, bakiyenizi aşıyor',
  'bet.noDebitYet': 'Bakiyeniz yalnızca sunucu bahsi kabul ettikten sonra değişir.',
  'bet.accepted': 'Bu turda kabul edilenler',
  'bet.pending': 'Sunucu bekleniyor…',
  'bet.result.accepted': '{selection} {amount}: kabul edildi',
  'bet.result.pending': '{selection} {amount}: kumarhane cüzdanının bahsi onaylaması bekleniyor — henüz kabul edilmedi',
  'bet.result.notConfirmed': '{selection} {amount}: kabul edilmedi — kumarhane cüzdanı bahsi onaylamadı',
  'bet.result.rejected': '{selection} {amount}: reddedildi — {reason}',
  'reason.WALLET_UNAVAILABLE': 'kumarhane cüzdanın şu an cevap vermiyor — hiçbir tutar çekilmedi; biraz sonra tekrar dene',
  'reason.BETTING_CLOSED': 'bahis kapanmıştı',
  'reason.INSUFFICIENT_FUNDS': 'yetersiz bakiye',
  'reason.SESSION_EXPIRED': 'site oturumunuz sona erdi — siteye dönüp oyunu yeniden açın',
  'reason.INVALID_STAKE': 'geçersiz tutar',
  'reason.CURRENCY_MISMATCH': 'para birimi uyuşmuyor',
  'reason.QUOTE_CHANGED': 'oran değişti',
  'reason.LIABILITY_LIMIT': 'limit doldu',
  'reason.SOURCE_UNAVAILABLE': 'kaynak kullanılamıyor',
  'reason.IDEMPOTENCY_CONFLICT': 'tekrarlanan istek çakıştı',
  'reason.DEBIT_UNRESOLVED_AT_CLOSE': 'ödeme kapanıştan önce onaylanmadı',
  'reason.ROUND_NOT_FOUND': 'tur bulunamadı',
  'reason.NETWORK': 'bağlantı sorunu, gönderilmedi',
  'result.final': 'Kesin sayım {count}',
  'result.winners': 'Kazanan: {list}',
  'result.youWon': '{amount} döndü',
  'result.youReturnedLess': '{amount} döndü (bahsinizden az)',
  'result.creditPending': 'Dönüş {amount} — ödeme bekleniyor',
  'result.noWin': 'Bu turda kazanç yok',
  'result.review': 'Belirsiz bir geçiş sonucu etkiliyor. Sonuç yayımlanmadı; inceleme zamanında bitmezse tur iptal edilir ve bahisler iade edilir.',
  'result.voided': 'Tur iptal edildi. Kabul edilen bahisler iade edilir.',
  'recent.title': 'Son sonuçlar',
  'recent.empty': 'Turlar bittikçe sonuçlar burada görünür.',
  'history.title': 'Bahis geçmişi',
  'funPlay.tag': 'EĞLENCE MODU',
  'funPlay.hint': 'Yalnızca oyun parası: gerçek bahis, istatistik veya ödül yok.',
  'stats.title': 'İstatistiklerim',
  'stats.rounds': 'tur',
  'stats.bets': 'bahis',
  'stats.winRate': 'kazanma',
  'stats.exact': 'tam isabet',
  'stats.best': 'en iyi kazanç',
  'stats.minutes': 'dakika oyun',
  'stats.money': 'Yatırılan {stake} · dönen {payout} · net {net}',
  'stats.last30': 'Son 30 gün: {rounds} tur, {wins} kazanç',
  'stats.favourite': 'favori: {sel}',
  'ri.title': 'Sayım nasıl yapılır',
  'ri.lead': 'Oynamadan önce: kamera, sarı çizgiyi okların yönünde geçen araçları sayar. Neyin sayıldığını burada görebilirsin.',
  'ri.direction.title': 'Yalnızca okların yönünde',
  'ri.direction.text': 'Çizgiyi sarı okların gösterdiği yönde geçen araçlar sayılır. Ters yönde geçen araçlar asla sayılmaz.',
  'ri.middle.title': 'Aracın ortası geçince sayılır',
  'ri.middle.text': 'Bir araç, ortası çizgiyi geçtiği anda sayılır — daha önce değil.',
  'ri.big.title': 'Her araç 1 sayılır',
  'ri.big.text': 'Otomobil, otobüs, kamyon ya da motosiklet: büyüklüğü ne olursa olsun her biri 1’dir.',
  'ri.hidden.title': 'Yalnızca kameranın gördüğü',
  'ri.hidden.text': 'Büyük bir aracın arkasında kalan ya da kadraja girmeyen araç sayılamaz.',
  'ri.others.title': 'Yaya ve bisiklet sayılmaz',
  'ri.others.text': 'Yayalar ve bisikletler hiçbir zaman sayılmaz.',
  'ri.time.title': 'Sayılan dakikanın içinde',
  'ri.time.text': 'Bahisler, sayılan 60 saniye başlamadan kapanır. Görüntüde sorun olursa tur iptal edilir ve tüm bahisler iade edilir.',
  'ri.dontShow': 'Bir daha gösterme',
  'ri.accept': 'Anladım — oyna',
  'ri.leave': 'Ana sayfaya dön',
  'ri.error': 'Onayın kaydedilemedi. Lütfen tekrar dene.',
  'wallet.down': 'Kumarhane cüzdanın şu an cevap vermiyor, bu yüzden senin için bahis durduruldu. Hiçbir tutar çekilmedi. Otomatik olarak yeniden deniyoruz — ya da siteye dönüp oyunu yeniden açabilirsin.',
  'history.empty': 'Henüz bahis yok.',
  'history.col.round': 'Tur',
  'history.col.pick': 'Seçim',
  'history.col.stake': 'Bahis',
  'history.col.odds': 'Oran',
  'history.col.count': 'Sayım',
  'history.col.return': 'Dönüş',
  'history.col.status': 'Durum',
  'history.evidence': 'Delil',
  'history.col.net': 'Net',
  'history.refunded': 'iade edildi',
  'history.persisted': 'Demo durumu bu tarayıcıda saklanır; yenileme bahisleri ne kaybettirir ne de yeniden ödetir. Yalnızca demo kolaylığıdır — üretim depolaması değildir.',
  'evidence.countedN': 'Sayılanlar ({n})',
  'evidence.excludedN': 'Sayılmayanlar ({n}) — pencere dışı, ters yön, hariç sınıf veya tekrar',
  'evidence.proof': 'İmzalar ve tanık',
  'evidence.manifestWitness': 'Manifesti tanık kaydetti',
  'evidence.resultWitness': 'Sonucu tanık kaydetti',
  'evidence.witnessNotIndependent': 'Tanık UrbanRats tarafından çalıştırılıyor (geliştirme); bağımsız değil.',
  'evidence.segments': 'Medya segmentleri (hash zinciri)',
  'evidence.problems': 'Kanıt sorunları',
  'evidence.redactedNote': 'Tekrar, gizlilik için küçültülmüş sürümü gösterir; hash’i orijinalin yanında kayıtlıdır.',
  'evidence.replayExpired': 'Tekrar bağlantısının süresi doldu veya kullanılamıyor.',
  'evidence.hashNote': 'Hash ve imzalar bu kayıtların tutarlı olduğunu ve tanık zamanında var olduğunu gösterir. Görüntünün gerçek ya da yapay zekâ sayımının doğru olduğunu kanıtlamaz.',
  'evidence.replay': 'Tekrar oynat',
  'evidence.jump': '{t} sn’den oynat',
  'evidence.window': 'Sayım penceresi (medya zamanı): {epoch} içinde {a}–{b} sn',
  'evidence.bettingClosed': 'Bahis kapanışı (sunucu saati): {t}',
  'evidence.recordedNote': 'Kayıt görüntü: sonuç önceden bilinebilirdi. Yalnızca işlev demosu.',
  'evidence.voided': 'Tur iptal edildi — sonuç yayımlanmadı ve kabul edilen bahisler iade edildi.',
  'evidence.reason': 'Gerekçe: {r}',
  'settings.clearDemo': 'Demo verisini sil ve baştan başla',
  'settings.clearDemoHint': 'Bu tarayıcıdaki demo turlarını, bahisleri ve bakiyeyi siler.',
  'settings.savedAt': 'Demo durumu bu tarayıcıya {t} anında kaydedildi.',
  'history.sessionOnly': 'Demo geçmişi yalnızca bu tarayıcıda saklanır (demo kolaylığı).',
  'bstate.SUBMITTED': 'Gönderildi',
  'bstate.DEBIT_PENDING': 'Ödeme bekleniyor',
  'bstate.ACCEPTED': 'Kabul edildi',
  'bstate.REJECTED': 'Reddedildi',
  'bstate.COMPENSATION_PENDING': 'İade bekleniyor',
  'bstate.COMPENSATED': 'İade edildi',
  'bstate.RESULT_WON': 'Kazandı · ödeniyor',
  'bstate.RESULT_LOST': 'Kaybetti · kapanıyor',
  'bstate.CREDIT_PENDING': 'Ödeme bekleniyor',
  'bstate.SETTLED': 'Sonuçlandı',
  'bstate.REFUND_PENDING': 'İade bekleniyor',
  'bstate.VOIDED': 'İptal · iade edildi',
  'rules.title': 'Kurallar',
  'rules.what': 'Chaos Lane, izlenen aracın alt orta noktası sayım penceresi içinde sayım çizgisi segmentini ok yönünde geçtiğinde aracı sayar.',
  'rules.classes': 'Sayılır: otomobil, otobüs, kamyon, motosiklet. Sayılmaz: bisiklet, ters yön, pencere dışındaki araçlar, aynı aracın ikinci geçişi.',
  'rules.window': 'Bahis, sayım başlamadan önce kapanır. Pencere [başlangıç, bitiş) şeklindedir: tam bitiş anındaki geçiş sayılmaz.',
  'rules.bands': 'Bu tur: L = {low}, H = {high}.',
  'rules.bandsCamera': 'L ve H her turda bu kameranın kendi trafiğinden belirlenir: son {n} sayılmış dakika (medyan {median}). Bahis açılmadan önce kilitlenir.',
  'rules.payout': 'Ödeme toplam dönüştür (bahis × oran). Net = dönüş − bahis. Oran, bahsiniz kabul edildiği anda sabitlenir.',
  'rules.review': 'Belirsiz bir geçiş sonucu değiştirebilecekse tur incelemeye gider. Çözülmeyen inceleme turu iptal eder ve bahisleri iade eder.',
  'rules.mode': 'Mevcut mod: {mode}. {hint}',
  'rules.demo': 'Bu bir demodur: demo para, örnek oranlar, bellekte tutulan durum.',
  'evidence.title': 'Tur delili',
  'evidence.status': 'Durum',
  'evidence.verified': 'Delil doğrulandı',
  'evidence.confirmed': 'AI sayımı bağımsız olarak doğrulandı',
  'evidence.no': 'Hayır',
  'evidence.yes': 'Evet',
  'evidence.manifest': 'Manifest hash',
  'evidence.config': 'Konfigürasyon hash',
  'evidence.events': 'Geçiş olayları',
  'evidence.counted': 'sayıldı',
  'evidence.notCounted': 'sayılmadı',
  'evidence.unavailable': 'Delil, tur sonucundan sonra kullanılabilir.',
  'evidence.simNote': 'SIMULATION_ONLY: olaylar bir fixture senaryosundan gelir. Gerçek trafik hakkında hiçbir şey kanıtlamaz.',
  'settings.title': 'Ayarlar',
  'settings.language': 'Dil',
  'settings.sound': 'Ses',
  'settings.soundOn': 'Açık',
  'settings.soundOff': 'Kapalı',
  'settings.motion': 'Azaltılmış hareket sistem ayarınızı izler ({state}).',
  'settings.motionOn': 'açık',
  'settings.motionOff': 'kapalı',
  'settings.resetDemo': 'Demo bakiyeyi sıfırla',
  'settings.resetDemoHint': 'Yalnızca demo. Bekleyen bahis varken kullanılamaz.',
  'settings.resetDone': 'Demo bakiye sıfırlandı.',
  'settings.resetBlocked': 'Bekleyen bahis varken sıfırlanamaz.',
  'session.title': 'Oturum sona erdi',
  'session.body': 'Güvenliğiniz için bu oyun oturumu sona erdi. Devam etmek için oyunu yeniden açın. Kabul edilmiş bahisler sunucuda sonuçlandırılır.',
  'session.reload': 'Oyunu yeniden aç',
  'session.lobby': 'Siteye dön',
  'error.fatal': 'Oyun başlatılamıyor',
  'nav.source': 'Kaynak',
  'source.title': 'Video kaynağı',
  'source.simulation': 'Simülasyon (video yok)',
  'source.simulationHint': 'Turlar senaryolu sayımlarla çalışır. Demo para ile bahis yapılabilir.',
  'source.use': 'Kullan',
  'source.inUse': 'Kullanımda',
  'source.available': 'Bu demoda kullanılabilir',
  'source.unavailable': 'Kullanılamaz',
  'source.licence': 'Lisans: {licence}',
  'source.owner': 'Sahibi: {owner}',
  'source.loadError': 'Kaynak listesi yüklenemedi.',
  'source.addTitle': 'Kullanma izniniz olan bir video ekleyin',
  'source.addFile': 'Video dosyası',
  'source.addRights': 'Bu videoyu bu yerel demoda kullanma hakkım var.',
  'source.addRightsNote': 'Bu beyan ticari veya yayın hakkını kanıtlamaz. Dosya bu tarayıcıda kalır; hiçbir şey yüklenmez. KAYIT DEMO olarak oynatılır.',
  'source.addAttribution': 'Kaynak / atıf (isteğe bağlı)',
  'source.addButton': 'Bu dosyayı oynat',
  'source.webcamNote': 'Yalnızca yerel test; hiçbir şey bu cihazdan çıkmaz.',
  'srcreason.SNAPSHOT_NOT_SUPPORTED': 'yalnızca durağan görüntü — geçiş gösteremez',
  'srcreason.REJECTED': 'şartlar/haklar nedeniyle reddedildi',
  'srcreason.RIGHTS_PENDING': 'kullanım izni henüz yok',
  'srcreason.QUARANTINED': 'karantinada',
  'srcreason.RIGHTS_EXPIRED': 'hakların süresi doldu',
  'srcreason.DISPLAY_NOT_PERMITTED': 'gösterim izni yok',
  'srcreason.CV_NOT_PERMITTED': 'video analizi izni yok',
  'srcreason.NO_ORIGIN': 'kayıtlı yayın adresi yok',
  'srcreason.MEDIA_FILE_MISSING': 'medya dosyası hazırlanmamış (npm run media:prepare)',
  'video.counterMissing': 'Sayım motoru henüz bağlı değil (P04): bu kaynakta tur ve bahis yok.',
  'video.uncalibrated': 'Kalibre edilmemiş önizleme çizgisi',
  'video.phase.idle': 'Boşta',
  'video.phase.loading': 'Yükleniyor',
  'video.phase.playing': 'Oynatılıyor',
  'video.phase.buffering': 'Arabelleğe alınıyor',
  'video.phase.paused': 'Duraklatıldı',
  'video.phase.ended': 'Bitti',
  'video.phase.error': 'Hata',
  'video.status.ONLINE': 'Görüntü iyi',
  'video.status.DEGRADED': 'Görüntü bozuk',
  'video.status.OFFLINE': 'Canlı görüntü yok',
  'video.error.NETWORK': 'Video yüklenirken ağ hatası oluştu.',
  'video.error.DECODE': 'Video çözülemedi (bozuk veya desteklenmeyen dosya).',
  'video.error.UNSUPPORTED_OR_BLOCKED': 'Kaynak yüklenemedi (desteklenmeyen biçim veya çapraz kaynak politikası engeli).',
  'video.error.ABORTED': 'Yükleme iptal edildi.',
  'video.error.PERMISSION_DENIED': 'Kamera izni reddedildi.',
  'video.error.NO_DEVICE': 'Kamera bulunamadı.',
  'video.error.DEVICE_ERROR': 'Kamera başlatılamadı.',
  'video.error.STREAM_LOST': 'Kamera yayını sona erdi.',
  'video.health.FROZEN': 'görüntü donmuş',
  'video.health.STALLED': 'yayın takıldı',
  'video.health.BUFFERING': 'arabelleğe alınıyor',
  'video.health.SOURCE_TOO_OLD': 'görüntü çok eski',
  'video.health.NOT_PLAYING': 'oynatılmıyor',
  'video.health.ERROR': 'hata',
  'video.health.AGE_UNKNOWN': 'yaş bilinmiyor',
  'video.reconnecting': 'Yeniden bağlanıyor…',
  'video.fps': '{n} fps',
  'video.epoch': 'Epoch {n}',
  'video.age': 'Yayın yaşı {s} sn (çekim zamanı değil)',
  'video.retry': 'Tekrar dene',
  'video.backToSim': 'Simülasyona dön',
  'bet.mediaBlocked': 'Video kaynağı sorunu — bahis kapalı ({reason}).',
  'vision.connecting': 'Sayım motoruna bağlanılıyor…',
  'vision.waiting-frame': 'Sayım motoru bağlı — ilk kare bekleniyor',
  'vision.ready': 'Videodan sayılıyor (çıkarım)',
  'vision.unavailable': 'Sayım motoruna ulaşılamıyor — başlatmak için: npm run vision:serve',
  'vision.error': 'Sayım motoru bu kaynak için hata bildirdi',
  'vision.waitingRound': 'Sıradaki video turu birazdan açılıyor.',
  'vision.lag': 'işçi görüntünün {s} sn gerisinde',
  'vision.ahead': 'işçi {s} sn önde — sonuçlar ancak kareleri gösterilince açılır',
  'cal.title': 'Kalibrasyon',
  'cal.note': 'Demo operatör aracı. Kaydedilen ayar bir sonraki tura kilitlenir (hash manifest içinde); süren tur kendi ayarını korur.',
  'cal.open': 'Kalibre et',
  'cal.setLine': 'Çizgiyi belirle (2 tık)',
  'cal.setRoi': 'Alanı belirle (tıklar)',
  'cal.finishRoi': 'Alanı bitir',
  'cal.flip': 'Yönü çevir',
  'cal.pickLine': 'Videoda sayım çizgisinin iki ucuna tıklayın.',
  'cal.pickRoi': 'Sayım alanının köşelerine tıklayın (şu ana kadar {n}), sonra Bitir.',
  'cal.classes': 'Sayılan sınıflar',
  'cal.minConf': 'En düşük güven {v}',
  'cal.hash': 'Ayar hash',
  'cal.saved': 'kayıtlı',
  'cal.invalid': 'Bir çizgi ve en az 3 köşeli bir alan gerekli.',
  'cal.save': 'Kalibrasyonu kaydet',
  'cal.cancel': 'Vazgeç',
  'cal.editing': 'Kalibrasyon düzenleniyor',
  'cal.notLocked': 'Çizgi henüz kilitli değil — sonraki tur kilitler',
  'cal.pending': 'yeni kalibrasyon süren turdan sonra uygulanır',
  'bet.noCounter': 'Bu kaynak için henüz sayım motoru yok — bahis kapalı.',
  'nav.wallet': 'Cüzdan',
  'nav.rewards': 'Ödüller',
  'nav.ranks': 'Sıralama',
  'ranks.title': 'Sıralamalar',
  'ranks.loading': 'Yükleniyor…',
  'ranks.empty': 'Şu an aktif bir sıralama yok.',
  'ranks.ends': 'bitiş {time}',
  'ranks.you': 'sen',
  'ranks.yourRank': 'Sıran',
  'ranks.notRanked': 'Sıralamaya girmek için en az {n} round oyna.',
  'ranks.prizes': 'Ödüller',
  'ranks.alias': 'Sıralamada {alias} olarak görünüyorsun — kişisel bilgi gösterilmez.',
  'ranks.hm': '{h} sa {m} dk',
  'ranks.m': '{m} dk',
  'metric.ROUNDS': 'Oynanan round',
  'metric.PLAY_TIME': 'Oyun süresi',
  'metric.BEST_MULTIPLIER': 'En yüksek çarpan',
  'metric.EXACT_HITS': 'Tam isabet',
  'metric.WINS': 'Kazanan bahis',
  'metric.ACTIVE_DAYS': 'Aktif gün',
  'metric.STAKE': 'Toplam bahis',
  'metric.NET_WIN': 'Net kazanç',
  'metric.BIGGEST_WIN': 'En büyük kazanç',
  'dropMetric.ROUNDS': '{target} round oyna',
  'dropMetric.WINS': '{target} bahis kazan',
  'dropMetric.EXACT_HITS': '{target} tam isabet yap',
  'dropMetric.BEST_MULTIPLIER': '{target} veya üstü çarpanla kazan',
  'drop.title': 'Drop kasası',
  'drop.goal': 'Hedef: {metric}',
  'drop.progress': 'ilerleme {progress} / {target}',
  'drop.open': 'Kasayı aç',
  'drop.ends': '{left} kaldı',
  'drop.left': '{n} kasa kaldı',
  'drop.empty': 'Tüm kasalar açıldı',
  'drop.won': 'Kazandın: {prize}!',
  'drop.fairTitle': 'Adil çekiliş',
  'drop.fair': 'Hedef ve ödüller kasa başlarken belirlendi. Bu, gizli tohumun hash değeridir; tohum kasa bitince gösterilir, böylece herkes çekilişi kontrol edebilir.',
  'prize.freebet': '{count} × {amount} freebet',
  'prize.boost': '+%{pct} kazanç artırımı',
  'approx.value': '~{amount}',
  'approx.title': 'Örnek kurla yaklaşık değer ({provider}, {rateId}, {asOf} itibarıyla). Bahis ve ödemeler {wallet} olarak kalır.',
  'approx.stale': 'kurun süresi doldu',
  'wallet.title': 'Cüzdan ve gösterim',
  'wallet.currency': 'Cüzdan para birimi',
  'wallet.fromOperator': 'Bu oturum için operatör açılışında belirlenir. Bahisler ve ödemeler her zaman bu para biriminde olur.',
  'wallet.asset': 'Varlık {asset} · ağ {network} · {scale} ondalık basamak · katalog {version}',
  'wallet.demoCatalogue': 'Demo katalog kaydı: herhangi bir partner sözleşmesini tanımlamaz.',
  'wallet.balance': 'Bakiye (tam değer)',
  'wallet.limits': 'Seçim başına bahis: {min} ile {max} arası',
  'wallet.display': 'Yaklaşık değeri şu birimde göster',
  'wallet.displayOff': 'Kapalı',
  'wallet.displayNote': 'Yalnızca yaklaşık (~), piyasa verisi olmayan örnek bir kurla. Ödeme hiçbir zaman para birimi değiştirmez.',
  'wallet.quote': '{provider} kaynağından {rateId} kuru, {asOf} itibarıyla, {ttl} sn geçerli. Örnek kur.',
  'wallet.quoteStale': 'Kurun süresi doldu; bu yüzden yaklaşık değer gösterilmiyor.',
  'wallet.quoteNone': 'Bu çift için kur yok; bu yüzden yaklaşık değer gösterilmiyor.',
  'wallet.region': 'Bölge (yalnızca öneri)',
  'wallet.regionNone': 'Seçilmedi',
  'wallet.regionNote': 'Bölge yalnızca dil ve gösterim para birimi önerir. Cüzdanınızı, bakiyenizi veya uygunluğunuzu değiştirmez.',
  'wallet.regionApply': 'Öneriyi uygula: {locale}, gösterim {display}',
  'wallet.cashier': 'Para yatırma, çekme ve ağ seçimi oyunun içinde değil, operatörünüzde yapılır.',
  'wallet.newSession': 'Demo: başka cüzdan para birimiyle yeni oturum',
  'wallet.newSessionHint': 'Başka bir cüzdan para birimi yeni bir oturum demektir. Her demo para biriminin kendi demo cüzdanı ve geçmişi vardır.',
  'wallet.newSessionBlocked': 'Açık bahis varken yapılamaz. Sonuçlanmalarını bekleyin.',
  'wallet.start': '{currency} oturumu başlat',
  'rewards.title': 'Ödüller',
  'rewards.demo': 'Demo ödüller. Gerçek para promosyonları kapalı.',
  'rewards.real': 'Bu sitede gerçek parayla ödül sunulmuyor.',
  'rewards.checkin': 'Günlük giriş',
  'rewards.checkinClaim': 'Giriş yap',
  'rewards.checkinDone': 'Bugün giriş yapıldı. Sonraki giriş: {t}.',
  'rewards.checkinGranted': 'Envanterinize eklendi: {item}',
  'rewards.checkinStreak': 'Art arda giriş günü: {n}',
  'rewards.checkinNote': 'UTC gününe bir giriş. Ödül kazanç ya da kayba bağlı değildir.',
  'rewards.level': 'Seviye {n}',
  'rewards.levelXp': '{xp} / {next} XP',
  'rewards.levelNote': 'Sonuçlanan her bahis, kazansa da kaybetse de ve tutardan bağımsız olarak aynı XP’yi verir. Yeni seviye envanterinize bir artırım ekler.',
  'rewards.inventory': 'Envanter',
  'rewards.empty': 'Henüz ödül yok.',
  'rewards.freebet': 'Freebet {amount}',
  'rewards.boost': 'Ödeme artırımı +%{pct}',
  'rewards.policy.PROFIT_ONLY': 'yalnız kâr: kazanırsa getiri eksi freebet değeri ödenir',
  'rewards.policy.STAKE_INCLUDED': 'bahis dahil: kazanırsa getirinin tamamı ödenir',
  'rewards.expires': 'Son geçerlilik {t}',
  'rewards.noExpiry': 'Süresiz',
  'rewards.state.GRANTED': 'Kullanılabilir',
  'rewards.state.RESERVED': 'Kullanımda',
  'rewards.state.CONSUMED': 'Kullanıldı',
  'rewards.state.CANCELLED': 'İptal edildi',
  'rewards.state.EXPIRED': 'Süresi doldu',
  'rewards.origin.OPERATOR_GRANT': 'Operatörden',
  'rewards.origin.DAILY_CHECKIN': 'Günlük giriş',
  'rewards.origin.LEVEL_UP': 'Seviye ödülü',
  'rewards.allGames': 'tüm oyunlar',
  'rewards.games': 'Geçerli olduğu oyunlar: {games}',
  'rewards.notMoney': 'Ödüller bakiyenizin parçası değildir.',
  'rewards.lightning': 'Lightning',
  'rewards.lightningBody': 'Bahis açıldığında Lightning, ana pazardaki bir seçimin oranını artırabilir. Artırım yalnızca o seçim kazanırsa ödemeyi değiştirir; sayımı veya sonucu asla etkilemez. Çekiliş bahislerden önce (hash ile) taahhüt edilir ve tohumu tur delillerinde yayımlanır; herkes kontrol edebilir.',
  'rewards.lightningCols': 'Seviye · olasılık · çarpan',
  'rewards.lightningExact': 'Tam sayı yan pazarı: Lightning havuzunda değil ({version}).',
  'rewards.terms': 'Şartlar',
  'rewards.cap': 'Bahis başına en yüksek toplam getiri: {cap}',
  'rewards.formula': 'Ödeme formülü ({version}): {formula}',
  'rewards.stackFreebetLightning': 'Freebet, Lightning seçimi üzerinde kullanılamaz.',
  'rewards.stackBoostLightning': 'Artırımlar aynı formülde Lightning ile birleşir.',
  'rewards.onePerBet': 'Bahis başına bir ödül; artırım en fazla +%{pct}.',
  'rewards.voidPolicy': 'Tur iptal edilirse kullanılan ödül, süresi dolmadıysa envanterinize geri döner.',
  'tier.COMMON': 'Yaygın',
  'tier.RARE': 'Nadir',
  'tier.EPIC': 'Epik',
  'tier.LEGENDARY': 'Efsanevi',
  'bet.lightning': '⚡ {tier} ×{factor}',
  'bet.lightningAria': 'Lightning {tier}: bu seçim kazanırsa ödeme ×{factor}',
  'bet.lightningNote': 'Lightning bu tur için sabittir ve yalnızca ödemeyi artırır. Seçimleriniz değişmez.',
  'bet.cap': 'Bahis başına en yüksek getiri: {cap}',
  'bet.reward': 'Ödül kullan',
  'bet.rewardNone': 'Ödül yok',
  'bet.rewardFreebet': 'Freebet {amount} ({policy})',
  'bet.rewardBoost': 'Artırım +%{pct}',
  'bet.rewardOneLine': 'Ödül tek bir seçime uygulanır. Taslakta tek seçim bırakın.',
  'bet.rewardFreebetHint': 'Freebet’i ({amount}) yerleştirmek için bir seçime dokunun. Nakit düşülmez.',
  'bet.rewardFreebetFace': 'Freebet tutarı {amount} olarak sabittir.',
  'bet.amount': 'Kendi tutarın',
  'bet.amountSet': 'Kullan',
  'bet.amountHint': 'Kendi biçiminizde yazın veya yapıştırın, örn. {example}',
  'bet.approxTotal': 'Yaklaşık {amount}',
  'amount.INVALID_DECIMAL': 'Geçerli bir tutar değil.',
  'amount.INVALID_ATOMIC': 'Geçerli bir tutar değil.',
  'amount.AMBIGUOUS_SEPARATORS': 'Ayraçlar sayı biçiminize uymuyor (örn. {example}).',
  'amount.PRECISION_OVERFLOW': '{currency} için ondalık basamak fazla (en çok {scale}).',
  'amount.NEGATIVE': 'Tutar negatif olamaz.',
  'amount.TOO_LARGE': 'Tutar çok büyük.',
  'amount.ZERO': 'Tutar sıfırdan büyük olmalı.',
  'amount.CURRENCY_MISMATCH': 'Yanlış para birimi.',
  'amount.LIMIT': 'Bahis sınırlarının dışında ({min} ile {max} arası).',
  'reason.STAKE_LIMIT': 'bahis sınırlarının dışında',
  'reason.REWARD_UNAVAILABLE': 'ödül kullanılamıyor',
  'reason.PROMO_NOT_STACKABLE': 'ödüller bu şekilde birleştirilemez',
  'history.freebet': 'Freebet',
  'history.lightning': 'Lightning ×{f}',
  'history.boost': 'Artırım +%{pct}',
  'history.cashDebit': 'Düşülen nakit',
  'evidence.lightning': 'Lightning',
  'evidence.lightningOk': 'Tohum taahhütle eşleşiyor ve yayımlanan artırımları yeniden üretiyor ✓',
  'evidence.lightningBad': 'Tohum kontrolü başarısız ✕',
  'evidence.lightningSeed': 'Tohum',
  'evidence.lightningCommit': 'Taahhüt',
  'evidence.lightningNone': 'Bu turda Lightning yok.',
  'settings.moreLocales': '{n} dil daha hazırlanıyor; tam çevrildiklerinde listelenecek.',
};
